module.exports = __webpack_public_path__ + "media/images/desktop/lets-tap-a2f4cee9f3d7d1eac2923bab99f7bc78.png";